import { fr } from './fr';

export const materialTableLocaleData = {
  fr: fr,
};
